<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <region
              :class-padding="classPadding"
              :title="'Regions'"
              :label="'Region'"
              v-model="selectedRegion"
              :code-value="false"
            ></region>
        </v-col>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <unit
            :class-padding="classPadding"
            :title="'Units'"
            :label="'Unit'"
            v-model="selectedUnit"
            :code-value="false"
          ></unit>
        </v-col>
         <v-col cols="12" md="3" sm="6" :class="classPadding">
          <area-lookup
            :class-padding="classPadding"
            :title="'Areas'"
            :label="'Area'"
            v-model="selectedArea"
            :code-value="false"
          ></area-lookup>
        </v-col>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <location
            :class-padding="classPadding"
            :title="'Locations'"
            :label="'Location'"
            v-model="selectedLoc"
            :code-value="false"
          ></location>
        </v-col>

        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <pay-house
            :class-padding="classPadding"
            :title="'Pay House'"
            :label="'Pay House'"
            v-model="selectedPayHouse"
            :code-value="false"
          ></pay-house>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
          <custom-datepicker :class-padding="classPadding" label="Initial Date" v-model="model.billInitDate"></custom-datepicker>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
          <custom-datepicker :class-padding="classPadding" label="Contract Date From" v-model="model.billContractDateFrom"></custom-datepicker>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
          <custom-datepicker :class-padding="classPadding" label="Contract Date To" v-model="model.billContractDateTo"></custom-datepicker>
        </v-col>
      </v-row>
       <span class="text-center body-2">Default Cut Off Date</span>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="2" :class="classPadding">
          <v-select label="From" :class="classPadding" :items="numberItems" v-model="model.billPeriod1DateFrom"></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="2" :class="classPadding">
          <v-select label="From" :class="classPadding" :items="numberItems" v-model="model.billPeriod2DateFrom"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="2" :class="classPadding">
          <v-select label="To" :class="classPadding" :items="numberItems" v-model="model.billPeriod1DateTo"></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="2" :class="classPadding">
          <v-select label="To" :class="classPadding" :items="numberItems" v-model="model.billPeriod2DateTo"></v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="12" xs="12" sm="4" md="2" :class="classPadding">
          <v-select label="Pay Out" :class="classPadding" :items="numberItems" v-model="model.billPeriod1PayOut"></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="2" :class="classPadding">
          <v-select label="Payout" :class="classPadding" :items="numberItems" v-model="model.billPeriod2PayOut"></v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="12" xs="12" sm="4" md="2" :class="classPadding">
          <v-select label="Period" :class="classPadding" :items="numberItems" v-model="model.billPeriod1Value"></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="2" :class="classPadding">
          <v-select label="Period" :class="classPadding" :items="numberItems" v-model="model.billPeriod2Value"></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
          <v-select label="Client Status" :class="classPadding" :items="['New','Active']" v-model="model.billClientStatus"></v-select>
        </v-col>

         <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
          <v-text-field label="Admin Fee" :class="classPadding" v-model="model.billAdminFee" type="number"></v-text-field>
        </v-col>
         <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
          <v-text-field label="Miscellaneous" :class="classPadding" v-model="model.billMiscellaneous" type="number"></v-text-field>
        </v-col>

         
      </v-row>
      <v-row>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <ecola
            :class-padding="classPadding"
            :title="'COLA'"
            :label="'COLA'"
            v-model="selectedEcola"
            :code-value="false"
          ></ecola>
        </v-col>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field label="Daily Amount" :class="classPadding" v-model="model.colaDailyAmount" type="number"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-checkbox label="LATE" :class="classPadding" v-model="model.colaLate"></v-checkbox>
        </v-col>
         <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-checkbox label="UNDERTIME" :class="classPadding" v-model="model.colaUnderTime"></v-checkbox>
        </v-col>
         <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-checkbox label="ABSENCES" :class="classPadding" v-model="model.colaAbsences"></v-checkbox>
        </v-col>
         <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-checkbox label="LEAVE" :class="classPadding" v-model="model.colaLeave"></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
         <v-col cols="12" md="4" sm="6" :class="classPadding">
          <v-checkbox label="With SIL Accrual for Billing" :class="classPadding" v-model="model.billWithSIL"></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field label="No. of Days" :class="classPadding" v-model="model.silNoOfDays" type="number"></v-text-field>
        </v-col>

         <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field label="Divisor" :class="classPadding" v-model="model.silDivisor	" type="number"></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field label="Terms of Payment (day/s)" :class="classPadding" v-model="model.silTermsOfPayment" type="number"></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field label="Vat Rate" :class="classPadding" v-model="model.vatRate" type="number"></v-text-field>
        </v-col>
      </v-row>

      
    </v-container>
  </div>
</template>
<script>
import isEmpty from "lodash/isEmpty"
const Region = () => import("../../personal-information/region/Lookup")
const Unit = () => import("../../employment-info/organizational-level/unit/Lookup")
const Location = () => import("../../employment-info/organizational-level/location/Lookup")
const Area = () => import("../../employment-info/organizational-level/area/Lookup")
const PayHouse = () => import("../../employment-info/organizational-level/pay-house/Lookup")
const CustomDatepicker = () => import("../../../../components/CustomDatepicker");
const Ecola = () => import("../../general/earnings-deductions/LookupEcola");

export default {
  props:[
    "value"
  ],
  data: () => ({
    classPadding: "my-0 py-0",
    model: {},
    selectedRegion: {},
    selectedUnit: {},
    selectedArea: {},
    selectedLoc: {},
    selectedPayHouse: {},
    selectedEcola: {},
    // selectedDed: {},
    numberItems: [...Array(32).keys()].slice(1)
  }),
  components: {
    Region,
    Unit,
    Location,
    AreaLookup: Area,
    PayHouse,
    CustomDatepicker,
    Ecola
  },
  methods: {
    emitValue() {
      this.$emit("input", this.model);
    }
  },
  watch: {
    selectedRegion(val) {
      this.model.regionCode = val.code;
      this.emitValue();
    },
    selectedUnit(val) {
      this.model.unitCode = val.code;
       this.emitValue();
    },
    selectedArea(val) {
      this.model.areaCode = val.code;
       this.emitValue();
    },
    selectedLoc(val) {
      this.model.locationCode = val.code;
       this.emitValue();
    },
    selectedPayHouse(val) {
      this.model.subAcctCode = val.code;
       this.emitValue();
    },
    selectedEcola(val) {
      this.model.colaEarnCode = val.code;
       this.emitValue();
    },
    // selectedDed(val) {
    //   this.model.deduction = val.code;
    //    this.emitValue();
    // },
    model: {
      handler(val){
        this.$emit("input", val);
      },deep: true
    }
  },
  mounted() {
    if(!isEmpty(this.value)) {
      this.model = Object.assign({},{ ...this.value, colaDailyAmount: this.value.colaDAmount});

      this.selectedRegion = {
        code: this.model.regionCode,
        desc: this.model.regionDesc
      }

      this.selectedUnit = {
        code: this.model.unitCode,
        desc: this.model.unitDesc
      }

      this.selectedArea = {
        code: this.model.areaCode,
        desc: this.model.areaDesc
      }

      this.selectedLoc = {
        code: this.model.localtionCode,
        desc: this.model.locationDesc
      }

      this.selectedPayHouse = {
        code: this.model.subAcctCode,
        desc: this.model.subAcctDesc
      }
       this.selectedEcola = {
        code: this.model.colaEarnCode,
        desc: this.model.colaEarnDesc
      }

    }
    
  }
}
</script>